export default "__VITE_ASSET__UVax0qFL__"